/* eslint-disable react/no-array-index-key */
/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { FiTrash } from 'react-icons/fi';
import {
  DropzoneContainer,
  DropzoneLabel,
  DropzoneContent,
  DropzoneIcon,
  DropzoneText,
  DropzoneInput,
  DropZoneItens,
  DropZoneItem,
} from './styles';

import { InputFieldProps } from '../InputField';
import ButtonSmall from '../ButtonSmall';

interface Props extends Omit<InputFieldProps, 'onChange'> {
  valueList?: File[];
  onChangeFiles?: (files: File[]) => void;
}

export const InputFieldFile = React.forwardRef<HTMLInputElement, Props>(
  ({ valueList, onChangeFiles, ...props }, ref) => {
    const onRemoveFile = React.useCallback(
      (index: number) => {
        if (!onChangeFiles || !valueList) return;
        const newFiles = valueList.filter((_, i) => i !== index);
        onChangeFiles(newFiles);
      },
      [onChangeFiles, valueList],
    );

    return (
      <DropzoneInput
        ref={ref}
        type="file"
        id={props.name}
        {...props}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
          if (!onChangeFiles) return;
          const prevFiles = valueList || [];
          const files = Array.from(e.target.files || []);
          onChangeFiles([...prevFiles, ...files].slice(0, 5));
        }}
      >
        <DropzoneContainer>
          {!valueList ||
            (valueList.length < 5 && (
              <DropzoneLabel htmlFor={props.name}>
                <DropzoneContent>
                  <DropzoneIcon />
                  <DropzoneText>Adicione até 5 arquivos</DropzoneText>
                </DropzoneContent>
              </DropzoneLabel>
            ))}
          {valueList && valueList.length > 0 && (
            <DropZoneItens>
              {valueList.map((file, index) => (
                <DropZoneItem key={index.toString()}>
                  <DropzoneIcon />
                  <p>{file.name}</p>
                  <ButtonSmall
                    style={{ marginLeft: 'auto' }}
                    onClick={() => onRemoveFile(index)}
                  >
                    <FiTrash size={16} />
                  </ButtonSmall>
                </DropZoneItem>
              ))}
            </DropZoneItens>
          )}
        </DropzoneContainer>
      </DropzoneInput>
    );
  },
);
